import React from 'react';
import {ArrowUpRight,Lock,ShieldCheck,X} from 'lucide-react';
import {useLang} from './i18n';
import {isSystemAccount} from './systemAccount';
import './official-system-profile.css';

export function OfficialAccountTag({person}:{person:{id?:string}|null|undefined}){
 const [,,tr]=useLang();
 return isSystemAccount(person)?<span className="official-account-tag" title={tr('Official MALVO system account','Offizielles MALVO-Systemkonto')}><ShieldCheck size={12} aria-hidden="true"/>{tr('OFFICIAL','OFFIZIELL')}</span>:null;
}

export function OfficialSafetyNotice({compact=false}:{compact?:boolean}){
 const [,,tr]=useLang();
 return <section className={'official-safety-notice'+(compact?' is-compact':'')} aria-label={tr('Account security','Kontosicherheit')}><ShieldCheck size={20} aria-hidden="true"/><div>
  {!compact&&<h3>{tr('Keep your credentials private','Schütze deine Zugangsdaten')}</h3>}
  <p>{tr('MALVO will never ask for your password, sign-in codes or recovery codes. Never share these with anyone.','MALVO fragt dich niemals nach deinem Passwort oder deinen Anmelde- und Wiederherstellungscodes. Teile diese Daten mit niemandem.')}</p>
 </div></section>;
}

export function OfficialSystemProfile({onClose,onOpenChat}:{onClose:()=>void;onOpenChat?:()=>void}){
 const [,,tr]=useLang();
 return <section className="official-system-profile">
  <div className="official-system-cover"><button type="button" aria-label={tr('Close','Schließen')} onClick={onClose}><X size={19}/></button></div>
  <div className="official-system-details"><div className="official-system-avatar"><img src="/icon.png" alt="MALVO"/></div>
   <h2>MALVO <OfficialAccountTag person={{id:'malvo-system'}}/></h2>
   <p className="official-system-description">{tr('Official announcements from the MALVO team. This system account only publishes messages; you cannot reply or send it friend requests.','Offizielle Ankündigungen des MALVO-Teams. Dieses Systemkonto veröffentlicht Nachrichten; Antworten und Freundschaftsanfragen sind deaktiviert.')}</p>
   <OfficialSafetyNotice/>
   <p className="official-system-readonly"><Lock size={15} aria-hidden="true"/>{tr('Read-only official chat','Offizieller Chat · nur zum Lesen')}</p>
   {onOpenChat&&<button type="button" className="official-system-open" onClick={onOpenChat}>{tr('Open announcements','Ankündigungen öffnen')}<ArrowUpRight size={16}/></button>}
  </div>
 </section>;
}
